export default __webpack_public_path__ + "static/media/hotel_2.1911d872.jpg";